import enLang from "./entries/en-US";
import thLang from "./entries/th-TH";

const AppLocale = {
  en: enLang,
  th: thLang,
};

export default AppLocale;
